import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import styled from 'styled-components'
import {Box, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import {isMobile} from 'react-device-detect'
import {AppAdminContext} from '../../app/AppAdminContext'
import {AdminDefaultMediumButton} from '../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../styledComponents/adminPage/Links'
import {AdminDialog} from '../shared/pageBaseComponents/AdminDialog'
import NatCondominiumSelectionComponent
    from '../../__NoAutomatedTests/components/common/admin/NatCondominiumSelectionComponent'
import {SELECT_CONDOMINIUM_TYPE} from '../../CodeMaster'
import NatCondominiumRepo from '../../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatCondominiumGroupRepo
    from '../../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../app/TypeHelpers'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {CondominiumInfo} from '../../__NoAutomatedTests/components/condominium/repository/NatGetCondominiumList'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

interface Props {
    location: Location
    natCondominiumRepo: NatCondominiumRepo
    natCondominiumGroupRepo: NatCondominiumGroupRepo
    eventEmitter: EventEmitterExAdmin
}

interface State {
    openDialog: boolean
    openSelectExcludeCondominiumDialog: boolean
    loginUserCondominiumGroupId: number | null
    selectedExcludeCondominiumInfo: CondominiumInfo[]
}

// TODO スマホ対応画面の動作確認用ページのため、リリース時には削除する
class AdminSupportSpTestPage extends Component<AdminPagePropsSet & Props, State> {
    declare context: React.ContextType<typeof AppAdminContext>

    constructor(props: Readonly<AdminPagePropsSet & Props>) {
        super(props)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        this.state = {
            openDialog: false,
            openSelectExcludeCondominiumDialog: false,
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            selectedExcludeCondominiumInfo: [],
        }
    }

    closeSelectCondominiumDiaLog = () => {
        this.setState({openSelectExcludeCondominiumDialog: false})
    }

    setSelectedExclusionCondominiumInfo = (selectedExcludeCondominiumInfo: CondominiumInfo[]) => {
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            openSelectExcludeCondominiumDialog: false,
        })
    }

    render(): ReactNode {
        const isProduction = window.location.hostname === 'www.suteki.haseko.jp'
        if (isProduction) {
            throw Error
        }

        const spMode = this.context.showSpModePage
        return <>
            {isMobile ?
                <div>スマホで表示しています</div>
                :
                <div>ＰＣで表示しています</div>
            }
            <div>AppAdminContext.showSpModePageの内容：{`${spMode}`}</div>
            <AdminDefaultMediumButton
                onClick={() => {
                    this.setState({openDialog: true})
                }}>
                ダイアログを表示する
            </AdminDefaultMediumButton>
            <Box height={'5px'}/>
            <AdminDefaultMediumButton
                onClick={() => {
                    this.setState({openSelectExcludeCondominiumDialog: true})
                }}>
                除外物件選択ダイアログを表示する
            </AdminDefaultMediumButton>
            <MobileFlex spMode={spMode}>
                {[...Array(10).keys()].map(i =>
                    <Box key={i} bgcolor={'coral'} height={'100px'} width={'100px'} margin={'20px'}>
                        {i + 1}番目のBox
                    </Box>,
                )}
            </MobileFlex>
            <AdminDialog
                open={this.state.openDialog}
                maxWidth={'md'}
            >
                <DialogTitle>
                    <div>ダイアログのサンプル</div>
                </DialogTitle>
                <DialogContent>
                    <MobileFlex spMode={spMode}>
                        {[...Array(4).keys()].map(i =>
                            <Box key={i} bgcolor={'skyblue'} height={'100px'} width={'100px'} margin={'20px'}>
                                {i + 1}番目のBox
                            </Box>,
                        )}
                    </MobileFlex>
                </DialogContent>
                <DialogActions>
                    <BackLink
                        onClick={() => {
                            this.setState({openDialog: false})
                        }}
                    >
                        キャンセル
                    </BackLink>
                </DialogActions>
            </AdminDialog>
            {this.state.openSelectExcludeCondominiumDialog &&
                <NatCondominiumSelectionComponent
                    selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                    condominiumRepo={this.props.natCondominiumRepo}
                    condominiumGroupRepo={this.props.natCondominiumGroupRepo}
                    closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                    setSelectedExclusionCondominiumInfo={this.setSelectedExclusionCondominiumInfo}
                    eventEmitter={this.props.eventEmitter}
                    selectedCondominiumGroupId={this.state.loginUserCondominiumGroupId}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    asyncCallFunction={this.props.asyncCallFunction}
                    excludeCondominium={this.state.selectedExcludeCondominiumInfo}
                />
            }
        </>
    }
}

AdminSupportSpTestPage.contextType = AppAdminContext

const MobileFlex = styled.div<{ spMode: boolean }>`
  display: flex;
  ${props => props.spMode ? `
    flex-flow: column nowrap;
  ` : `
    flex-flow: row wrap;
  `}
`

export default createAdminPage(AdminSupportSpTestPage)
